// Feeling: how a character looks from this moment on. Adding shows a row for everyone on screen; changing one shows just
// that character. A feeling is saved as soon as it is picked.
import type { Emotion } from "../../../model/face";
import { addMarker, feelingAt, markById, onScreen, setMarker } from "../../../model/timeline";
import { Section } from "../../common";
import { useTimeline } from "../TimelineLoader";
import type { PageProps } from "./index";
import { FeelingRows } from "./LineStartSections";
import { PageShell } from "./shared";

export function FeelingPage({ t, editId, onClose }: PageProps) {
  const { ep, update } = useTimeline();
  const here = onScreen(ep, t);
  const edited = editId ? markById(ep, "feeling", editId) : undefined;
  const people = edited ? [edited.char] : here;
  // A feeling picked for someone sets their marker at t (one of theirs already there is replaced), or changes the edited one.
  const pick = (c: string, e: Emotion) => {
    if (edited) return update(x => setMarker(x, "feeling", edited.id, { emotion: e }), { merge: `feel-${edited.id}` });
    update(x => addMarker(x, "feeling", t, { char: c, emotion: e }), { merge: `feel-${c}-${t}` });
  };
  return (
    <PageShell title="Expression" t={t} editing={!!edited} onClose={onClose}>
      {people.length
        ? <Section title="How do they look?"><FeelingRows people={people} now={c => (edited ? edited.emotion : feelingAt(ep, c, t))} onPick={pick} /></Section>
        : <p className="hint">Nobody is on screen at this moment. Place a face on the picture first (select the picture, then Faces).</p>}
    </PageShell>
  );
}
